<template>
  <div v-cloak class="exam">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: paths }">{{
          title
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>考试</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 测试题目 -->
    <div style="text-align: center; color: #000000; font-size: 20px">
      {{ examtitle }}
    </div>
    <div v-cloak v-show="status" class="topic">
      <!-- 左边 -->
      <div v-cloak class="topic-left">
        <!-- 单选 -->
        <div
          :id="'s' + rexam.Id"
          v-for="(rexam, index) in radios"
          :key="index"
          class="topic-list"
        >
          <div class="topic-title">
            {{ index + 1 }}. {{ rexam.Title }}
            <span class="IsRequired" v-show="rexam.IsRequired">*</span>
          </div>
          <el-radio-group
            @change="changeradio(radio[index], index + 1, rexam.Id)"
            class="xuan"
            v-model="radio[index]"
          >
            <el-radio
              v-for="(rexams, indexs) in rexam.AnswerItems"
              :key="indexs"
              :label="rexams.Id"
              >{{ rexams.Title }}</el-radio
            >
          </el-radio-group>
        </div>
        <!-- 多选 -->
        <div
          :id="'s' + cexam.Id"
          v-for="(cexam, item) in checks"
          :key="item + 10"
          class="topic-list"
        >
          <div class="topic-title">
            <!-- {{ (len + item + 1) | che() }}{{ cexam.Title }} -->
            {{ dx + item }}.{{ cexam.Title }}
            <span class="IsRequired">(多选)</span>
            <span class="IsRequired" v-show="cexam.IsRequired">*</span>
          </div>
          <el-checkbox-group
            @change="changecheck(checkList[item], dx + item, cexam.Id)"
            v-model="checkList[item]"
          >
            <el-checkbox
              v-for="(cexams, items) in cexam.AnswerItems"
              :key="items"
              :label="cexams.Id"
              >{{ cexams.Title }}</el-checkbox
            >
          </el-checkbox-group>
        </div>

        <div @click="sub" class="subs">确认提交</div>
      </div>
      <!-- 右边 -->
      <div class="topic-right">
        <div class="exam-right">
          <div class="titles-right">考试信息</div>
          <div class="mes">
            <div>开始时间：{{ examtime }}</div>
            <!-- <div>考试总分：{{ examscore }}分</div> -->
            <div>答题限时：{{ examlimit }}秒</div>
            <div>
              已用时：
              <span>{{ realtime }}</span>
              秒
            </div>
          </div>
          <div class="titles-right">答题卡</div>
          <div class="clip">
            <div
              @click.stop="scrolls('s' + clips.Id)"
              v-for="(clips, ins) in merge"
              :key="ins"
              :class="[clips.act == true ? 'active' : 'clip-list']"
            >
              {{ ins + 1 }}
            </div>
            <div class="clip-b">蓝色表示已填写，点击单元格可直接跳转到该题</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.exam {
  min-width: 1200px;
  min-height: 500px;
  background: #ffffff;
  .duo {
    margin-top: 10px;

    .el-textarea__inner {
      border-radius: 12px;

      border: 1px solid rgba(151, 151, 151, 1);
    }
  }

  .breadcrumb {
    width: 1200px;
    margin: 0 auto;
    margin-top: 38px;
    margin-bottom: 65px;
  }
  .topic {
    width: 1200px;
    padding-bottom: 60px;
    box-sizing: border-box;
    // height: 900px;
    display: flex;
    justify-content: flex-start;
    margin: 0 auto;
    .IsRequired {
      color: red;
    }
    .topic-left {
      width: 900px;

      margin-top: 40px;
      .topic-title {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #000000;
      }
      .topic-list {
        margin-bottom: 30px;
        .el-radio__input.is-checked .el-radio__inner {
          border-color: #000000;
          background: #000000;
        }
        .el-radio__label {
          color: #767676;
        }
        .el-radio__inner:hover {
          border-color: #000000;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          border-color: #000000;
          background: #000000;
        }
        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #767676;
        }
        .el-checkbox__inner:hover {
          border-color: #000000;
        }
      }
      .xuan {
        display: flex;
        flex-direction: column;
        .el-radio {
          margin-top: 21px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(118, 118, 118, 1);
        }
      }
      .el-checkbox-group {
        display: flex;
        flex-direction: column;
        .el-checkbox {
          margin-top: 21px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(118, 118, 118, 1);
        }
      }
      .subs {
        width: 294px;
        height: 54px;
        background: rgba(15, 117, 189, 1);
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: rgba(255, 255, 255, 1);
        line-height: 54px;
        text-align: center;
        margin-top: 56px;
        cursor: pointer;
      }
    }
    .topic-right {
      width: 260px;
      height: 100%;

      // position:fixed;
      // top:50%;
      // right:0;

      .exam-right {
        position: fixed;
        width: 260px;
        top: 20%;
        background: #ffffff;
        // z-index: 9999999999;

        box-sizing: border-box;
      }

      .titles-right {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: rgba(0, 0, 0, 1);
        margin-bottom: 24px;
      }
      .titles-right:before {
        content: "|";
        display: inline-block;
        width: 4px;
        height: 26px;
        background: rgba(15, 117, 189, 1);
        color: rgba(15, 117, 189, 1);
        border-radius: 2px;
        margin-right: 8px;
      }
      .mes {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(0, 0, 0, 1);
        margin-bottom: 30px;
        div {
          margin-top: 15px;
        }
        span {
          font-size: 30px;
          font-family: MicrosoftYaHei;
          color: rgba(15, 117, 189, 1);
        }
      }
      .clip {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .clip-list {
          width: 40px;
          height: 40px;
          border: 1px solid rgba(209, 219, 234, 1);
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #000000;
          background: #ffffff;
          cursor: pointer;
          // background: rgba(15, 117, 189, 1);
        }
        .active {
          width: 40px;
          height: 40px;
          border: 1px solid rgba(209, 219, 234, 1);
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #ffffff;
          background: rgba(15, 117, 189, 1);
          cursor: pointer;
        }
        .clip-b {
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: rgba(118, 118, 118, 1);
          margin-top: 15px;
        }
      }
    }
  }
}
</style>
<script>
import { gettitle, subexam } from "../api.js";
export default {
  name: "Exam",
  components: {},
  data() {
    return {
      fetch_static: false,
      radio: [], //单选model数组
      radioend: [], //选中的单选题数组
      checkList: [], //多选model数组
      checkend: [], //多选答案数组
      paths: "", //上一级路由地址
      title: "", //上一级路由名称
      radios: [], //单选题数组
      checks: [], //多选数组
      textarea: [], //多文本数组
      texts: [], //多文本model数组
      te: [], //多文本答案数组
      must: [], //题必答数组
      merge: [],
      len: "", //单选题目长度
      checklen: "", //多选题目长度
      examid: "", //考试id
      kid: "", //课程id
      examtitle: "", //考试标题
      examtime: "", //开始时间
      examlimit: "", //考试限时
      examscore: "", //考试总分
      realtime: 0, //实时时间
      timer: null,
      loading: false,
      alls: [], //所有
      answer: [], //已选的
      sid: "", //学习id
      status: false,
      ctime: false, //是否超时
      tj: true, //提交成功
    };
  },

  created() {
    let path = this.$route.query.paths;
    let titles = this.$route.query.name;
    this.paths = path;
    this.title = titles;
    let examid = localStorage.getItem("examid");
    let kid = localStorage.getItem("kid");
    // let sid = localStorage.getItem('sid');
    this.examid = examid;
    this.kid = kid;
    let radioend = JSON.parse(localStorage.getItem("radioend")) || [];
    let checkend = JSON.parse(localStorage.getItem("checkend")) || [];
    let realtime = localStorage.getItem("realtime") || 0; //当前时间
    if (radioend.length > 0 || checkend.length > 0) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "#0000000",
      });
      this.realtimes();
      this.status = true;
      this.examtime = localStorage.getItem("examtime"); //开始时间
      this.examtitle = localStorage.getItem("examtitle"); //考试标题
      this.examlimit = localStorage.getItem("examlimit"); //考试限时
      // this.examscore = localStorage.getItem('examscore'); //考试总分
      this.realtime = realtime; //医用时间

      this.radioend = radioend;
      let r = JSON.parse(localStorage.getItem("radio")) || [];
      this.merge = JSON.parse(localStorage.getItem("merge"));

      let merge = this.merge;
      let radio = merge.filter((radios) => {
        return radios.InputType == "radio";
      });
      this.radios = radio; //题目
      this.len = this.radios.length;

      let ra = [];
      // 设置单选动态model
      for (let i = 0; i < radio.length; i++) {
        ra.push("radio");
      }

      let s = [...r, ...ra];
      this.radio = [...new Set(s)];

      this.checkend = checkend;
      let cx = JSON.parse(localStorage.getItem("checkList")) || []; //多选id数组
      this.merge = JSON.parse(localStorage.getItem("merge"));

      // let merge = this.merge
      let chec = merge.filter((ss) => {
        return ss.InputType == "checkbox";
      });

      this.checks = chec;
      this.checklen = this.checks.length;

      let ch = [];
      for (let i = 0; i < chec.length; i++) {
        let checkss = [];
        ch.push(checkss);
      }

      let cxs = [...cx, ...ch];
      this.checkList = [...new Set(cxs)];

      //筛选必答题
      let mes = this.merge;
      mes.forEach((musts) => {
        if (musts.IsRequired == true) {
          this.must.push(musts.Id);
        }
        this.alls.push(musts.Id);
      });

      loading.close();
    } else {
      this.titles();
    }
  },
  filters: {},
  computed: {
    dx() {
      let len = this.len;

      return len + 1;
    },
    dw() {
      let len = this.len;
      let checklen = this.checklen;
      let dws = checklen + len;
      return dws + 1;
    },
  },
  //离开组件
  beforeRouteLeave(to, from, next) {
    let radioend = JSON.parse(localStorage.getItem("radioend")) || [];
    let checkend = JSON.parse(localStorage.getItem("checkend")) || [];
    let ss = this.test || radioend.length > 0 || checkend.length > 0;
    let ti = !this.ctime;
    if (ti && ss && this.tj) {
      this.$confirm("您确定离开考试吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          next();
        })
        .catch(() => {});
    } else {
      next();
    }
  },
  

  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  watch:{
    $route(to){
      if(to.name=='Exam'){
        this.titles()
      }
    }
  },
  methods: {
    // 刷选单选多选
    screen() {
      let test = this.test;

      // 单选
      let radio = test.filter((radios) => {
        return radios.InputType == "radio";
      });

      this.radios = radio;
      this.len = this.radios.length;
      localStorage.setItem("radios", JSON.stringify(radio));

      // 设置单选动态model
      for (let i = 0; i < this.radios.length; i++) {
        this.radio.push("radio");
      }

      // 多选
      let check = test.filter((checks) => {
        return checks.InputType == "checkbox";
      });

      this.checks = check;
      this.checklen = this.checks.length;
      localStorage.setItem("checks", JSON.stringify(this.checks));

      // 设置多选动态model
      for (let i = 0; i < this.checks.length; i++) {
        let checks = [];
        this.checkList.push(checks);
      }

      this.merge = [...this.radios, ...this.checks];

      //筛选必答题
      test.forEach((musts) => {
        if (musts.IsRequired == true) {
          this.must.push(musts.Id);
        }
        this.alls.push(musts.Id);
      });
    },
    //获取题目
    titles() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "#0000000",
      });
      let examid = this.examid;
      let kid = this.kid;
      let token = localStorage.getItem("AccessToken");
      let datas = {
        examId: examid,
        courseId: kid,
        token: token,
        source: "pc",
      };

      gettitle(datas)
        .then((res) => {
          if (res.data.Code == 0) {
            console.log(res);
            this.status = true;
            let da = res.data.Data;
            this.test = da.List;
            localStorage.setItem("test", da.List);
            this.examtime = da.Exam.DateTime;
            this.examtitle = da.Exam.Title;
            this.examlimit = da.Exam.LimitTime;
            // this.examscore = da.Exam.Score;
            localStorage.setItem("examtime", this.examtime); //开始时间
            localStorage.setItem("examtitle", this.examtitle); //考试标题
            localStorage.setItem("examlimit", this.examlimit); //考试限时
            // localStorage.setItem('examscore', this.examscore); //考试总分
            loading.close();
            this.screen();
            this.realtimes();
          } else {
            loading.close();

            this.$alert(res.data.Message, "提示", {
              confirmButtonText: "确定",
              showClose: false,
              callback: () => {
                this.$router.go(-1);
              },
            });
          }
        })
        .catch((error) => {
          loading.close();
          console.log(error);
        });
    },

    //计时器
    realtimes() {
      this.timer = setInterval(() => {
        this.realtime++;
        let examlimit = localStorage.getItem("examlimit");
        localStorage.setItem("realtime", this.realtime); //当前时间

        if (this.realtime > examlimit) {
          this.ctime = true;
          clearInterval(this.timer);
          this.timer = null;
          this.$confirm("您已超时请重新答题!!!", "提示", {
            confirmButtonText: "确定",
            type: "warning",
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
          }).then(() => {
            localStorage.removeItem("radioend");
            localStorage.removeItem("checkend");
            localStorage.removeItem("realtime");
            localStorage.removeItem("examtime");
            localStorage.removeItem("examtitle");
            localStorage.removeItem("examlimit");
            localStorage.removeItem("radios");
            localStorage.removeItem("radio");
            localStorage.removeItem("merge");
            localStorage.removeItem("checks");
            localStorage.removeItem("checkList");
            this.$router.go(-1);
          });
        }
      }, 1000);
    },

    // 点击单选选项
    changeradio(xid, index, tid) {
      let radioend = this.radioend;

      if (radioend.length >= 1) {
        for (var i = 0; i < radioend.length; i++) {
          if (radioend[i].QuestionId == tid) {
            this.radioend.splice(i, 1);
            continue;
          }
        }
        this.radioend.push({
          QuestionId: `${tid}`,
          QuestionItemIds: [`${xid}`],
          AnswerText: null,
        });
      } else {
        this.radioend.push({
          QuestionId: `${tid}`,
          QuestionItemIds: [`${xid}`],
          AnswerText: null,
        });
      }

      localStorage.setItem("radioend", JSON.stringify(this.radioend)); //缓存单选答案对象数组
      localStorage.setItem("radio", JSON.stringify(this.radio)); //缓存单选model数组
      this.move(index);
      this.fetch_static = false;
    },

    // 点击多选选项
    changecheck(xid, item, tid) {
      let checkend = this.checkend;
      if (checkend.length > 0) {
        for (let i = 0; i < checkend.length; i++) {
          if (checkend[i].QuestionId == tid) {
            this.checkend.splice(i, 1);
            continue;
          }
        }

        this.checkend.push({
          QuestionId: `${tid}`,
          QuestionItemIds: xid,
          AnswerText: null,
        });

        this.checkend = this.checkend.filter((item) => {
          return item.QuestionItemIds.length > 0;
        });
      } else {
        this.checkend.push({
          QuestionId: `${tid}`,
          QuestionItemIds: xid,
          AnswerText: null,
        });
      }

      localStorage.setItem("checkend", JSON.stringify(this.checkend)); //缓存多选答案对象数组
      localStorage.setItem("checkList", JSON.stringify(this.checkList)); //缓存多选model数组
      this.dmove(item);
      this.fetch_static = false;
    },

    // 单选联动
    move(index) {
      this.$set(this.merge[index - 1], "act", true);
      localStorage.setItem("merge", JSON.stringify(this.merge)); //缓存答题卡
    },
    //多选联动
    dmove(index) {
      let dx = this.checkList;
      let len = this.len;
      let dlen = index - len - 1; //这道题在多选数组中的下标

      if (dx[dlen].length >= 1) {
        this.$set(this.merge[index - 1], "act", true);
      } else {
        this.$set(this.merge[index - 1], "act", false);
      }
      localStorage.setItem("merge", JSON.stringify(this.merge)); //缓存答题卡
    },

    //点击滚动到制定位置
    scrolls(id) {
      this.$el.querySelector(`#${id}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "center", //区域中间
      });
    },
    // 提交
    sub() {
      let that = this;

      if (that.fetch_static) {
        let mustss = that.must; //必答题id
        let answer = [...that.radioend, ...that.checkend, ...that.te]; //答案数组
        that.answer = answer;
        let answers = answer.map((item) => {
          return item.QuestionId;
        });

        let allid = this.alls; //所有题目id

        let arr = []; //没选中的数组题目
        allid.forEach((item) => {
          !answers.includes(item)
            ? arr.push({
                QuestionId: item,
                QuestionItemIds: [],
                AnswerText: null,
              })
            : "";
        });

        let alls = [...arr, ...answer];

        console.log(alls);

        if (answer == "") {
          that.$message.error("您还未答题！");
          return;
        }

        // 判断有无必答题未答
        for (let i = 0; i < mustss.length; i++) {
          if (answers.indexOf(mustss[i]) < 0) {
            that.$message.error("您有必答题未答！");
            return false;
          }
        }
        return;
      } else {
        that.fetch_static = true;
      }

      if (that.fetch_static) {
        let token = localStorage.getItem("AccessToken");
        let examid = localStorage.getItem("examid");
        let kid = localStorage.getItem("kid");
        let examtime = localStorage.getItem("examtime");
        let radioend = JSON.parse(localStorage.getItem("radioend"));
        let checkend = JSON.parse(localStorage.getItem("checkend"));
        let mustss = that.must; //必答题id
        let answer = [...that.radioend, ...that.checkend, ...that.te]; //答案数组
        that.answer = answer;
        let answers = answer.map((item) => {
          return item.QuestionId;
        });

        let allid = this.alls; //所有题目id

        let arr = []; //没选中的数组题目
        allid.forEach((item) => {
          !answers.includes(item)
            ? arr.push({
                QuestionId: item,
                QuestionItemIds: [],
                AnswerText: null,
              })
            : "";
        });

        let alls = [...arr, ...answer];
        if (answer == "") {
          that.$message.error("您还未答题！");
          return;
        }

        // 判断有无必答题未答
        for (let i = 0; i < mustss.length; i++) {
          if (answers.indexOf(mustss[i]) < 0) {
            that.$message.error("您有必答题未答！");
            return false;
          }
        }
		console.log(examtime)
		//更改属性名称，大写转小写
		alls= alls.map(item=>{
			return {
				questionItemIds:item.QuestionItemIds,
				questionId:item.QuestionId,
				answerText:item.AnswerText
			}
		})
        let datas = {
          source: "pc",
          token: token,
          courseId: kid,
          examId: examid,
          answerSheet: alls,
        //   StartTime: examtime,
        };
        subexam(datas)
          .then((res) => {
            console.log(res);
            if (res.data.Code == 0) {
              console.log("成功");
              this.fetch_static = true;
              this.tj = false;
              clearInterval(this.timer);
              this.timer = null;
              localStorage.setItem("examsuccessid", res.data.Data.Id);
              if (radioend || checkend) {
                localStorage.removeItem("radioend");
                localStorage.removeItem("checkend");
                localStorage.removeItem("realtime");
                localStorage.removeItem("examtime");
                localStorage.removeItem("examtitle");
                localStorage.removeItem("examlimit");

                localStorage.removeItem("radios");
                localStorage.removeItem("radio");
                localStorage.removeItem("merge");
                localStorage.removeItem("checks");
                localStorage.removeItem("checkList");
              }

              that.$message({
                message: "提交成功",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  path: "/Exam-detail",
                  query: {
                    paths: "/Exam",
                    name: "考试",
                    ExamSubmitId: res.data.Data.Id,
                  },
                });
              }, 1500);
            } else {
              this.$message.error(res.data.Message);
              this.fetch_static = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.fetch_static = false;
          });
      }
    },
  },
};
</script>


